import React from 'react';
import { mockTestimonials, mockUpcomingEvents, mockBlogPosts } from '../mock';

export const GlobalFootprintSection = () => {
  return (
    <section id="global-footprint" className="py-20" style={{ backgroundColor: 'var(--pink-blush)' }}>
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="lhsc-heading text-3xl md:text-4xl text-center mb-12">
          OUR GLOBAL FOOTPRINT
        </h2>

        {/* Stats Display */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="text-5xl lhsc-heading mb-2" style={{ color: 'var(--mauve-rose)' }}>
              1,900+
            </div>
            <p className="lhsc-subheading text-sm" style={{ color: 'var(--slate-grey)' }}>
              Lady Hustlers Worldwide
            </p>
          </div>
          <div className="text-center">
            <div className="text-5xl lhsc-heading mb-2" style={{ color: 'var(--mauve-rose)' }}>
              195K+
            </div>
            <p className="lhsc-subheading text-sm" style={{ color: 'var(--slate-grey)' }}>
              Women Reached Globally
            </p>
          </div>
          <div className="text-center">
            <div className="text-5xl lhsc-heading mb-2" style={{ color: 'var(--mauve-rose)' }}>
              25+
            </div>
            <p className="lhsc-subheading text-sm" style={{ color: 'var(--slate-grey)' }}>
              Countries
            </p>
          </div>
        </div>

        {/* Details */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lhsc-subheading text-sm">
          <div>
            <p className="mb-2"><strong style={{ fontWeight: 400 }}>Headquarters:</strong> Montreal, Canada</p>
            <p className="mb-2"><strong style={{ fontWeight: 400 }}>Registration:</strong> Federally and provincially registered nonprofit (Canada)</p>
            <p className="mb-2"><strong style={{ fontWeight: 400 }}>Recognition:</strong> Listed on the UN Partner Portal</p>
          </div>
          <div>
            <p className="mb-2"><strong style={{ fontWeight: 400 }}>Google for Nonprofits:</strong> Active participant</p>
            <p className="mb-2"><strong style={{ fontWeight: 400 }}>Operating across:</strong> North America, Europe, the Middle East, Africa, and beyond</p>
          </div>
        </div>

        <div className="mt-8 text-center lhsc-body">
          <p>Our work is: <strong style={{ fontWeight: 400 }}>Locally rooted · Globally aligned · Culturally respectful · Institutionally credible</strong></p>
        </div>
      </div>
    </section>
  );
};

export const MissionSection = () => {
  return (
    <section id="mission" className="py-20" style={{ backgroundColor: 'var(--white-soft)' }}>
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="lhsc-heading text-3xl md:text-4xl text-center mb-12">
          OUR MISSION
        </h2>

        <div className="lhsc-body space-y-6">
          <p>
            The mission of The Lady Hustler Society Club is to advance the economic empowerment, education, and leadership of women — 
            particularly those who are underrepresented, underserved, or facing systemic barriers — through accessible education, 
            professional development, entrepreneurship support, and community-driven humanitarian action.
          </p>

          <p>The organization exists to reduce economic and opportunity gaps affecting women by:</p>

          <ul className="space-y-3 pl-6">
            <li className="flex items-start">
              <span className="mr-2" style={{ color: 'var(--mauve-rose)' }}>•</span>
              <span>Providing educational programs, training, and resources that strengthen professional and entrepreneurial capacity</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2" style={{ color: 'var(--mauve-rose)' }}>•</span>
              <span>Creating pathways to dignified work, income generation, and business development</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2" style={{ color: 'var(--mauve-rose)' }}>•</span>
              <span>Fostering inclusive, global networks that support collaboration, mentorship, and peer learning</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2" style={{ color: 'var(--mauve-rose)' }}>•</span>
              <span>Mobilizing community-based humanitarian initiatives that address urgent needs such as food insecurity and access to essential resources</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2" style={{ color: 'var(--mauve-rose)' }}>•</span>
              <span>Promoting ethical governance, safeguarding, transparency, and accountability in all programs and partnerships</span>
            </li>
          </ul>

          <p>
            The Lady Hustler Society Club operates as a nonprofit, non-partisan, and non-profit-distributing organization, 
            reinvesting its resources into programs that benefit women and communities locally and globally.
          </p>
        </div>
      </div>
    </section>
  );
};

export const PublicEventsSection = () => {
  return (
    <section id="public-events" className="py-20" style={{ backgroundColor: 'var(--white-soft)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="lhsc-heading text-3xl md:text-4xl text-center mb-12">
          FREE RESOURCES. OPEN TO ALL.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Networking Events */}
          <div className="p-8 border border-[var(--pink-dusty)] bg-white">
            <h3 className="lhsc-heading text-xl mb-4">Bi-Weekly Public Networking Events</h3>
            <p className="lhsc-body text-sm mb-6">
              Free and open to all. Connect with female entrepreneurs and professionals at all stages. 
              Build relationships, share insights, and grow together.
            </p>
            <a
              href="https://calendar.google.com/calendar/u/2?cid=aGVsbG9AZW50cmVwcmVuZXVybGFkeWh1c3RsZXIuY29t"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 rounded-md text-white font-semibold text-sm tracking-wider"
              style={{ 
                backgroundColor: 'var(--mauve-rose)',
                fontFamily: 'Josefin Sans, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: 500
              }}
            >
              View Upcoming Events →
            </a>
          </div>

          {/* Audio Conferences */}
          <div className="p-8 border border-[var(--pink-dusty)] bg-white">
            <h3 className="lhsc-heading text-xl mb-4">Bi-Weekly Audio Conferences on Clubhouse</h3>
            <p className="lhsc-body text-sm mb-6">
              Free and open to all. Join dynamic discussions, expert interviews, and real conversations on business, 
              leadership, and impact — no video required.
            </p>
            <a
              href="https://theladyhustlersocietyclub.myflodesk.com/lhscnewsletter"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 rounded-md text-white font-semibold text-sm tracking-wider"
              style={{ 
                backgroundColor: 'var(--mauve-rose)',
                fontFamily: 'Josefin Sans, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontWeight: 500
              }}
            >
              Follow Us on Clubhouse →
            </a>
          </div>

          {/* Open Access Resources */}
          <div className="p-8 border border-[var(--pink-dusty)] bg-white">
            <h3 className="lhsc-heading text-xl mb-4">Open Access Resources</h3>
            <p className="lhsc-body text-sm mb-6">
              Our blog, social media channels, and newsletters offer free resources to empower female entrepreneurs and professionals. 
              From expert insights to practical guides and inspiring stories — knowledge should be shared widely.
            </p>
            <div className="space-y-2">
              <a
                href="https://theladyhustlersocietyclub.myflodesk.com/lhscnewsletter"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-6 py-3 rounded-md text-center text-white font-semibold text-sm tracking-wider"
                style={{ 
                  backgroundColor: 'var(--mauve-rose)',
                  fontFamily: 'Josefin Sans, sans-serif',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  fontWeight: 500
                }}
              >
                Subscribe to Newsletter →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-20" style={{ backgroundColor: 'var(--pink-blush)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="lhsc-heading text-3xl md:text-4xl text-center mb-12">
          WHAT OUR COMMUNITY SAYS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {mockTestimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="p-8 bg-white border border-[var(--pink-dusty)] relative"
            >
              {/* Oval Frame Accent */}
              <div 
                className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-16 h-16 rounded-full border-2 bg-white flex items-center justify-center"
                style={{ borderColor: 'var(--mauve-rose)' }}
              >
                <span className="text-4xl lhsc-heading" style={{ color: 'var(--mauve-rose)' }}>"</span>
              </div>

              <div className="mt-8">
                <p className="lhsc-body text-sm mb-6 italic">
                  {testimonial.quote}
                </p>
                <div className="text-center">
                  <p className="lhsc-heading text-base mb-1">{testimonial.name}</p>
                  <p className="lhsc-subheading text-xs" style={{ color: 'var(--slate-grey)' }}>
                    {testimonial.title}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const WordsToLiveBySection = () => {
  return (
    <section id="words-to-live-by" className="py-20" style={{ backgroundColor: 'var(--white-soft)' }}>
      <div className="max-w-4xl mx-auto px-6">
        <div className="space-y-12">
          <div className="text-center">
            <blockquote className="lhsc-pull-quote text-2xl md:text-3xl">
              "Education opens doors. Redistribution keeps them open."
            </blockquote>
          </div>

          <div className="ornament">+</div>

          <div className="text-center">
            <blockquote className="lhsc-pull-quote text-2xl md:text-3xl">
              "No woman should choose between survival and ambition."
            </blockquote>
          </div>

          <div className="ornament">+</div>

          <div className="text-center">
            <blockquote className="lhsc-pull-quote text-2xl md:text-3xl">
              "We don't wait for seats — we build tables long enough for all of us."
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export const ManifestoSection = () => {
  return (
    <section id="manifesto" className="min-h-screen flex items-center justify-center py-20" style={{ backgroundColor: 'var(--white-soft)' }}>
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="decorative-rule mb-12"></div>

        <div className="space-y-8 mb-12">
          <h2 className="lhsc-heading text-3xl md:text-4xl leading-relaxed">
            "WE DO NOT EXTRACT."<br />
            "WE DO NOT PERFORM IMPACT."<br />
            "WE DO NOT RUSH GROWTH."
          </h2>

          <div className="decorative-rule"></div>

          <h2 className="lhsc-heading text-3xl md:text-4xl leading-relaxed">
            "WE BUILD CAREFULLY."<br />
            "WE REDISTRIBUTE INTENTIONALLY."<br />
            "WE MOVE TOGETHER."
          </h2>

          <div className="decorative-rule"></div>

          <h2 className="text-4xl md:text-5xl lhsc-heading leading-relaxed" style={{ color: 'var(--mauve-rose)' }}>
            "BECAUSE THE ONLY THING THAT MOVES FASTER<br className="hidden md:block" /> THAN MONEY IS SOLIDARITY."
          </h2>
        </div>

        <div className="ornament mb-12">+</div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://entrepreneurladyhustler.com/en/become-a-lady-hustler/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 rounded-md text-white font-semibold text-sm tracking-wider"
            style={{ 
              backgroundColor: 'var(--mauve-rose)',
              fontFamily: 'Josefin Sans, sans-serif',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              fontWeight: 500
            }}
          >
            Become a Lady Hustler
          </a>
        </div>
      </div>
    </section>
  );
};
